






























































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class CaseShowFrame extends Vue {
    swiperOption_teacher = {
        direction: "horizontal",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        effect: "coverflow",
        speed: 1000,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
        },
        coverflowEffect: {
            stretch: 10,
            slideShadows: true,
        },
        on: {
            init: function (swiper: any) {
                console.log("teacherSwiper初始化");
            },
        },
    };
    headImgData = [
        {
            name: "瓦列里·邦杜（俄罗斯）",
            title: "国际欧亚科学院院长、中科院外籍院士",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E7%93%A6%E5%88%97%E9%87%8C%C2%B7%E9%82%A6%E6%9D%9C.jpg",
            videoUrl: "",
            intro: "<p>瓦列里·邦杜，男，俄罗斯国籍，空间地球科学家。1947年10月生于原苏联波尔塔瓦，1980年获工学博士学位，1990年获理学博士学位。2003年当选俄罗斯科学院院士。现任俄罗斯科学院副院长、国际欧亚科学院院长，兼任俄罗斯联邦教育和科学部／俄科院空间观测科学研究所所长。2017年当选为中国科学院外籍院士。邦杜教授的主要学术贡献是为创建针对海洋、大气、陆地和近地空间的空间观测系统提供了理论基础和方法论，并在自然灾害监测、环境保护、海洋探测和相关地球科学研究方面取得了系统性成就。</p><p>近20年来邦杜院士积极开展与中国科技界的合作，在三个方面做出贡献：1）为丝绸之路经济带中俄交通走廊建设做出贡献。他任中俄基金合作项目“基于数字地球理论的中俄交通走廊研究－以丝绸之路沿线地区为例”和金砖国家专项中国、巴西、俄罗斯带路环境遥感合作项目总负责人，为一带一路环境问题研究提供了新的方法和技术；2）为我国成为泛欧亚科学实验计划（PEEX）发起国做出贡献。PEEX是一面向全球环境变化研究的长期国际科学计划，他与芬兰、中国科学家合作，使PEEX成为由芬、俄、中主导的大型科学计划，并在中科院遥感地球所设立了PEEX计划北京办公室；3）为推动国际欧亚科学院（IEAS）中国科学中心的发展做出贡献。作为IEAS院长，长期以来他对IEAS中国中心的建立、建设和发展发挥了重要作用。目前IEAS中国中心拥有160多名院士，其中近三分之一同时也是中科院、工程院院士。</p>",
        },
        {
            name: "维克多 • 萨维内赫（俄罗斯）",
            title: "国际欧亚科学院副院长、俄罗斯科学院院士、苏联英雄称号获得者",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E7%BB%B4%E5%85%8B%E5%A4%9A%20%E2%80%A2%20%E8%90%A8%E7%BB%B4%E5%86%85%E8%B5%AB.jpg",
            videoUrl: "",
            intro: "<p>苏联宇航员、科学家、高校系统人才储备组织专家、技术科学博士， 俄罗斯科学院通讯院士、两次获得“苏联英雄称号”。苏维埃共和国和俄罗斯联邦共和国国家奖金获得者。1988至2007年，担任莫斯科大地测量和测量制图大学校长、俄罗斯水晶罗盘国家奖金专家委员会成员。2011年被选举为俄联邦基洛夫州立法会统一选区《统一俄罗斯》党代表。1978年12月8日加入宇航员队伍，参加了三次宇航飞行。</p>",
        },
        {
            name: "夏泽翰（巴基斯坦）",
            title: "联合国教科文组织驻华代表、教授",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%A4%8F%E6%B3%BD%E7%BF%B0.jpg",
            videoUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/video/03%20%E5%A4%8F%E6%B3%BD%E7%BF%B0%E8%87%B4%E8%BE%9E%E8%A7%86%E9%A2%91.mp4",
            intro: "<p>联合国教科文组织总干事奥德蕾·阿祖莱任命夏泽翰教授为联合国教科文组织驻华代表处代表，联合国教科文组织驻朝鲜民主主义人民共和国、日本国、蒙古国、中华人民共和国和大韩民国代表。夏泽翰教授在过去的31年中一直致力于土木工程、水文、环境法、环境经济以及国际环境科学等领域的研究。自2005年至就任驻华代表之前，夏教授曾在印度尼西亚雅加达担任联合国教科文组织亚太科学局主任及教科文组织驻印度尼西亚、文莱达鲁萨兰国、马来西亚、菲律宾和东帝汶代表。</p><p>夏泽翰教授于2008年加入联合国教科文组织，时任教科文组织总部自然科学部门水资源和可持续发展处主任。在加入联合国教科文组织之前，曾在澳大利亚和巴基斯坦从事科研、咨询和政策工作。他的工作成果在中国也受到了高度认可，于2019年和2017年分获得“中国政府友谊奖”与“北京市长城友谊奖”。夏泽翰教授于1990年在巴基斯坦拉合尔工程技术大学获得土木工程理学学士（荣誉）、并获英国伯明翰大学水资源技术与管理理学硕士（1992）和土木工程博士（1995）、澳大利亚麦考瑞大学国际环境法学硕士（2005），英国伦敦帝国理工学院应用环境经济学硕士（2007）等学位。</p>",
        },
        {
            name: "张振山（中国）",
            title: "联合国人居署北京代表处项目主任",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%BC%A0%E6%8C%AF%E5%B1%B1.jpg",
            videoUrl: "",
            intro: "<p>1983至1996年就职于中国住房和城乡建设部城市建设司、办公厅和外事司；1996至2001年中国常驻联合国人居署代表处副代表。2002-2004年任联合国人居署物流官员，在伊拉克从事石油换食品项目；2005年至 2009年任联合国人居署亚洲城市水项目中国首席技术顾问在南京、昆明、绵阳等城市开展水与卫生项目；2009年至今任联合国人居署中国项目主任。</p><p>长期从事城市建设、管理和国际交流等工作，在可持续城市发展、改善城市公共空间、城市应对气候变化、城市繁荣指数、城市环境管理、城市水与卫生等方面有着丰富的经验。担任联合国人居署中国项目主任以来，促成联合国人居署与与中方有关方面签署了合作协议；探索与中国政府、大学、科研设计机构、非政府组织、基金会、以及私营企业开展良好的合作。</p>",
        },
        {
            name: "徐冠华（中国）",
            title: "国际欧亚科学院院士、中国科学院院士、科技部原部长",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%BE%90%E5%86%A0%E5%8D%8E.jpg",
            videoUrl: "",
            intro: "<p>国家科技部原部长，第十一届全国政协常委、教科文卫体委员会主任；中国科学院院士，第三世界科学院院士，瑞典皇家工程科学院外籍院士，国际宇航科学院院士，欧亚科学院院士。 </p><p>2010 年任国家重大科学研究计划——全球变化研究专家组组长；2011 年任国家重大基础研究发展计划（973 计划）专家顾问组组长。</p>",
        },
        {
            name: "张景安（中国）",
            title: "国际欧亚科学院院士、国际欧亚科学院中国科学中心常务副主席",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%BC%A0%E6%99%AF%E5%AE%89.jpg",
            videoUrl: "",
            intro: "<p>博士、研究员、国际欧亚科学院院士、曾任国家科委体制改革司副司长，国家科委人才分㳘办公室主任，国家科委科技扶贫办主任，中国农村技术开发中心主任，科技部火炬高技术开发中心主任兼任科技型中小企业创新基金管理中心主任、政策法规与体制改革司司长，科技部秘书长，党组成员、科技日报社长、第十一届全国政协委员、中国髙新技术产业开发区协会理事长、中国民营科技实业家协会常务副理事长，中国科技金融促进会风险投资专委会主任等。现任中国科技体制改革研究会理事长，高新技术开发区改革专委会会长，国际欧亚科学院中国中心副主席等。</p>",
        },
        {
            name: "刘燕华（中国） ",
            title: "国际欧亚科学院院士、科技部原副部长",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%88%98%E7%87%95%E5%8D%8E.jpg",
            videoUrl: "",
            intro: "<p>国家气候变化专家委员会主任、创新方法研究会理事长，原科技部副部长、党组成员。 </p><p>刘燕华部长长期从事创新方法、气候变化、资源环境、绿色发展、风险管理和可持续发展等领域的研究和科技管理工作，现任创新方法研究会理事长、国家气候变化专家委员会主任、国家生态环境保护专家委员会副主任、中国可持续发展研究会顾问、国际风险管理理事会（IRGC）顾问等。</p>",
        },
        {
            name: "吉库诺夫（俄罗斯）",
            title: "国际欧亚科学院第一副院长",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%90%89%E5%BA%93%E8%AF%BA%E5%A4%AB.jpg",
            videoUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/video/04%20%E5%90%89%E5%BA%93%E8%AF%BA%E5%A4%AB%E8%87%B4%E8%BE%9E%E8%A7%86%E9%A2%91.mp4",
            intro: "<p>吉库诺夫以 14 种语言在 28 个国家出版了 500 多部著作，包括 19 部专著和教科书。他目前感兴趣的领域是地理信息学、可持续发展、应用制图和数学制图建模。他因在数学制图建模方面的杰出表现获得了 D.N. Anuchin 奖，他还因开发俄罗斯环境和自然资源地图集而获得俄罗斯联邦政府科学技术奖。</p><p>吉库诺夫曾在俄罗斯和多所外国大学任教，包括布尔诺（捷克斯洛伐克）、纽约州和加利福尼亚州（美国）、约翰内斯堡（南非）、瓦赫宁根和恩斯赫德（荷兰）、剑桥（英国）、圣地亚哥（智利）、哈瓦那（古巴）、广州和乌鲁木齐（中国）、塞瓦斯托波尔（当时在乌克兰）、雷克雅未克（冰岛）、日内瓦（瑞士）、阿斯塔纳（哈萨克斯坦）和柏林（德国）等多个国家和地区的大学。2003 年以来，先后在乌克兰、土耳其和中国四次举办地理信息学现代问题暑期班。他被选为香港中文大学地球与空间信息科学研究所科学委员会委员。1996 年起担任国际制图协会副主席、委员会主席和工作组主席，该协会协调 80 多个国家在制图和地理信息系统领域的活动。16 年间（1991-2003 年，2008-2012 年），吉库诺夫担任国际地理联盟地理信息科学委员会委员，他还是俄罗斯自然科学学院（信息学和控制论系）和欧亚国际科学院的正式成员。指导了多项国家和国际项目，其中包括：俄罗斯基础研究基金会、RGNF、俄罗斯大学 - 基础研究、“整合”计划、麦克阿瑟基金会、INTAS、RSS、NWO 等。</p>",
        },
        {
            name: "黄维（中国） ",
            title: "国际欧亚科学院院士、中国科学院院士、西北工业大学学术委员会主任",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E9%BB%84%E7%BB%B4.jpg",
            videoUrl: "",
            intro: "<p>中国科学院院士、俄罗斯科学院外籍院士，西北工业大学学术委员会主任，亚太工程组织联合会主席。国家特聘专家，国家杰出青年科学基金获得者，教育部长江学者，国家重点研发计划首席科学家，国家杰出青年科学基金评审委员会委员。两次获得国家自然科学奖二等奖、四次获得高等学校科学研究优秀成果奖（科学技术）自然科学奖一等奖、六次获得江苏省科学技术奖以及何梁何利基金科学与技术进步奖、中国电子学会自然科学奖一等奖，成果入围中国“高等学校十大科技进展”。在世界顶尖期刊 Nature、Science、Nature Electronics、 Nature Energy、Nature Materials、Nature Nanotechnology、Nature Photonics、Nature Communications、Research、npj Flexible Electronics 等上发表研究论文 900 余篇，h 因子为 150，国际同行引用逾 10 万次，是科瑞唯安材料科学与化学领域全球高被引学者，获授权美国、新加坡和中国等国发明专利 360 余项，出版了《有机电子学》《生物光电子学》《有机薄膜晶体管材料器件和应用》《有机光电子材料在生物医学中的应用》《OLED 显示技术》等学术专著。</p>",
        },
        {
            name: "徐锭明（中国）",
            title: "国家能源局原局长",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%BE%90%E9%94%AD%E6%98%8E.jpg",
            videoUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/video/05%20%E5%BE%90%E9%94%AD%E6%98%8E.mp4",
            intro: "<p>曾任国务院参事、国家发展改革委能源局局长、国家能源领导小组办公室副主任。高级工程师。长期从事能源发展战略研究、规划编制、重大工程实施等工作。2014 年 12 月被聘任为国务院参事室特约研究员。</p>",
        },
        {
            name: "詹姆斯·田（美国）",
            title: "美国国家工程院院士，迈阿密大学工程学院院长、IEEE 总会副主席",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E8%A9%B9%E5%A7%86%E6%96%AF%C2%B7%E7%94%B0.jpg",
            videoUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/video/06%20%E8%A9%B9%E5%A7%86%E6%96%AF%C2%B7%E7%94%B0.mp4",
            intro: "<p>美国国家工程院院士，迈阿密大学工程学院院长。毕业于麻省理工学院，取得电子工程学硕士和博士学位，是美国国家工程院最有威望的院士之一，曾担任国际电气与电子工程师协会（IEEE）总会副主席、执行委员会主席、产品委员会主席、期刊委员会主席等重要职务以及贝尔电话实验室和兰德公司的领导职务。</p>",
        },
        {
            name: "廖兵（中国）",
            title: "国际欧亚科学院院士、广东省科学院党委书记",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%BB%96%E5%85%B5.jpg",
            videoUrl: "",
            intro: "<p>高分子化学与物理学专家，国际欧亚科学院院士，研究员，博士生导师。1999年获中国科学院化学研究所博士学位，现任广东省科学院党委书记，兼任广东省科协副主席、省政协科教卫体委员会副主任。中共广东省委委员，政协广东省委员会第十一届、十二届委员。曾任中科院纤维素化学重点实验室主任、中科院广州化学有限公司总经理、董事长。</p><p>廖兵长期从事生物基有机新材料和功能高分子材料的应用基础研究和高技术研发，在生物基有机新材料和功能高分子材料的设计、合成与有机功能新材料研发方面，开展了系统性和创新性的研究并取得了突出成绩，取得了系列核心技术专利，成果技术水平位居国内领先或国际先进，部分技术成果实现了规模产业化。廖兵在科技发展战略、规划及科研管理等方面亦有出色表现，通过科技体制机制创新实践，突破研究机构事业属性的束缚，在省级科学院率先建立了以市场为导向的技术创新生态系统，形成了可复制推广的经验模式，发挥了积极示范作用。</p>",
        },
        {
            name: "周少奇（中国） ",
            title: "国际欧亚科学院院士、贵州大学副校长",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%91%A8%E5%B0%91%E5%A5%87.jpg",
            videoUrl: "",
            intro: "<p>贵州大学副校长，国际欧亚科学院院士。1993年获大连理工大学博士学位。1993年至1997年，华南理工大学发酵工程博士后，香港大学环境工程副研究员。2002年，在英国皇家学会资助的密德萨斯大学任客座教授，2009年，担任加拿大滑铁卢大学客座资深研究员。2016年，获“万人计划”领军人才奖，2009年被评为“珠江学者”特聘教授。2015年，成为国际水协厌氧中国分会董事会成员。主要研究方向：环境生物技术、固体废物管理与垃圾渗滤液处理、生物脱氮除磷的电子化学计量学、MFC、城乡/家庭污水处理技术等。先后获得世界知识产权组织优秀专利奖1项、国家科学技术奖1项、国家专利奖4项、何梁何利科技创新奖、贵州省政府科学技术奖一等奖，省级科技一等奖7项，发表学术论文440余篇，出版专著10部，申请中、美、澳专利140项(授权专利90余项)。</p>",
        },
        {
            name: "梅杰乌 • 阿克梅特卡尔（哈萨克斯坦）",
            title: "哈萨克斯坦国家地理研究所所长",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E6%A2%85%E6%9D%B0%E4%B9%8C%20%E2%80%A2%20%E9%98%BF%E5%85%8B%E6%A2%85%E7%89%B9%E5%8D%A1%E5%B0%94.jpg",
            videoUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/video/07%20%E6%A2%85%E6%9D%B0%E4%B9%8C%20%E2%80%A2%20%E9%98%BF%E5%85%8B%E6%A2%85%E7%89%B9%E5%8D%A1%E5%B0%94.mp4",
            intro: "<p>哈萨克斯坦国家地理研究所所长，哈萨克斯坦地理和水安全研究所董事会主席，哈萨克斯坦共和国国家科学院院士 </p><p>1995年1月26日获得地理学博士学位 </p><p>1998年10月9日获得地理学教授职称 </p><p>2005年3月10日被国际生态、人类和自然安全科学院评选为科学院极端事件学部成员（院士） </p>",
        },
        {
            name: "邓伟（中国）",
            title: "国际欧亚科学院院士、四川师范大学教授",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E9%82%93%E4%BC%9F.jpg",
            videoUrl: "",
            intro: "<p>博士，教授, 研究生导师（硕士、博士），国际欧亚科学院院士，四川省学术和技术带头人。担任中国自然资源学会副理事长（常务理事），中国地理学会山地分会主任委员（理事），《山地学报》主编，曾主持国家973项目（首席科学家）、中国科学院重大和重点项目、科技部国际援外重点合作项目、国家自然科学基金面上项目和重点项目等，主要从事山区资源环境与区域国土空间发展、中尼地理和南亚地理与资源环境等研究。创建了中尼地理联合研究中心。 发表论文（含合作者）300余篇；主编出版《南亚地理：资源与环境》等7部专著；提交科技咨询报告12份；2016年荣获中国科学技术协会“全国优秀科技工作者”。</p>",
        },
        {
            name: "李中（中国）",
            title: "国际欧亚科学院院士、中海油研究总院有限责任公司 副总经理兼总工程师",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E6%9D%8E%E4%B8%AD.jpg",
            videoUrl: "",
            intro: "<p>我国海洋油气钻完井技术领域知名专家，教授级高工，博士生导师，荣获全国劳动模范荣誉称号、全国五一劳动奖章，国家“万人计划”科技创新领军人才，“何梁何利”科学与技术创新奖，“全国石油石化优秀科技工作者”，享受国务院特殊津贴。</p><p>研究的技术成果获国家科技进步奖一等奖1项（排名第1），国家技术发明奖二等奖1项（排名第2），省部级科技进步一等奖及以上12项（其中6项排名第1）；作为负责人的“南海高温高压钻完井技术研究与应用创新团队”入选国家科技部重点领域创新团队；发表核心期刊论文42篇、编写著作9部、发明专利23件、企业标准2部、软件著作权7项。</p>",
        },
        {
            name: "曹和平（中国）",
            title: "北京大学教授",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E6%9B%B9%E5%92%8C%E5%B9%B3.jpg",
            videoUrl: "",
            intro: "<p>发展金融博士、北京大学经济学院教授，博士生导师；北京大学数字经济与区块链实验室首席专家；北京大学环境资源与产业经济学系创系主任。中国政治经济学会副会长，多个省和国家中心城市经济顾问；深圳市湾区数字经济与科技研究院院长。</p><p>研究领域集中在数字经济、产业园区、货币资本一级市场、非银行系、宏观经济、环境经济方面。近年来出版中英文著作多种，在《中国社会科学》、《经济研究》、《北京大学学报》等刊物和北京大学出版社，牛津大学出版社发表论文和出版专著多卷。 参与多个交易所、银行和非银机构的组建和运营管理，并卓有成效。发表《中国产权市场蓝皮书》、《中国私募股权市场蓝皮书》（8个年度）</p>",
        },
        {
            name: "何逢阳（中国） ",
            title: "安徽省界首市市委书记",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E4%BD%95%E9%80%A2%E9%98%B3.jpg",
            videoUrl: "",
            intro: "<p>现任界首市委书记，安徽阜阳界首高新技术产业开发区党工委书记、管委会主任，中山大学行政管理专业毕业，管理学博士。参加工作以来，先后在省、市、县等多平台锻炼，在政策研究机关、经济发展一线、基层地方治理等多岗位历练，具有丰富的基层实践经验和理论素质修养。主政界首以来，界首连续四年GDP增幅居安徽省第一，连续五年进入全国投资潜力百强县前十，界首荣获首批国家创新型县（市），获批全国循环经济示范园区，成为全国唯一创建国家高新区的贫困县。</p>",
        },
        {
            name: "张全国（中国）",
            title: "工学博士，教授，博士生导师",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E5%BC%A0%E5%85%A8%E5%9B%BD.jpg",
            videoUrl: "",
            intro: "<p>工学博士，教授，博士生导师。任第十一届和十二届全国政协委员、第十二届全国政协教科文卫体委员会委员、农业农村部科学技术委员会委员、国际生物过程学会（IBA）会士、中国农业工程学会副理事长、中国高等教育学会工程热物理专委会副理事长、农业农村部可再生能源新材料与装备重点实验室主任、河南农业大学原副校长等职务。作为国家级骨干教师和享受国务院政府特殊津贴专家，长期从事可再生能源科学与农业工程领域的教学科研工作，主持承担了多项国家重点研发计划、国家“863计划”、国家自然科学基金、国家公益性行业科研专项等研究项目，其中1项获国家科技进步二等奖、1项获国家级教学成果二等奖、1项获中国专利优秀奖、2项获河南省科技进步一等奖、1项获省级教学成果特等奖、9项获省部级科技进步二等奖，主持创建世界上最大的太阳能光合生物制氢装置，主编8部学术专著，发表论文300余篇（其中SCI一区论文48篇，高被引论文8篇），取得了多项国际领先水平的研究成果，为可再生能源与农业工程专业教育及科学技术发展作出了贡献。</p>",
        },
        {
            name: "昆特·皮特尔 - 郭（奥地利） ",
            title: "奥地利新丝绸之路协会副会长",
            imgUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/%E6%98%86%E7%89%B9%C2%B7%E7%9A%AE%E7%89%B9%E5%B0%94%20-%20%E9%83%AD.jpg",
            videoUrl: "https://ittn.oss-cn-beijing.aliyuncs.com/2021%E8%A5%BF%E5%AE%89/guest/video/08%20%E6%98%86%E7%89%B9%C2%B7%E7%9A%AE%E7%89%B9%E5%B0%94%20-%20%E9%83%AD.mp4",
            intro: `<p>1964年11月， 博士毕业于维也纳大学。2004年9月至今，担任国际关系和欧洲事务顾问。</p><p>欧洲理事会（Council of Europe）前秘书长（1999年-2004年）</p><p>前欧洲委员会议会成员（1991年-1999年）</p><p>前奥地利议会成员（1971年-1999年）</p><p style="font-weight:normal;color:#000">专业特长：</p><p>拥有资深的国际政治交流与合作经验,以及广阔的欧洲政治网络联系,尤其是中欧和东欧地区。</p><p>与联合国、阿拉伯国家联盟、伊斯兰合作组织在社会保障和社会住房、卫生政策、行政改革,公共管理民主化、人权、法治、跨文化和宗教等领域有密切的交流。</p><p style="font-weight:normal;color:#000">社会活动：</p><p>担任世界公共论坛-文明对话联合主席（维也纳/莫斯科）</p><p>担任新丝绸之路协会主席（维也纳）</p><p>担任德国柏林文明研究所董事会对话副监督员（柏林）</p><p style="font-weight:normal;color:#000">其他：</p><p>2010年1月-2010年12月，担任世界核安全研究所顾问服务（奥地利）</p><p>2009年10月-2010年6月，担任社会保障部空间规划与环境保护项目研究（黑山共和国）</p><p>2006年1月-2008年1月，为财政部、劳工部、就业和社会政策部门提供咨询服务（塞尔维亚）</p><p>2005年7页-2007年6月，担任政府欧盟事务工作顾问（马其顿）</p>`,
        },
    ];
    siwperData_reverse: any = [];
    iskeepAutoplay: boolean = true;
    headImgHoverIndex: number = -1;
    isTeacherSwiperRun: boolean = true;

    handelCaseItem(e: any, item: any, key: any) {
        if (item.videoUrl) {
            this.isTeacherSwiperRun = false;
            //@ts-ignore
            this.$refs.teacherSwiper.$swiper.autoplay.stop();
            (this.$parent as any).openVideoDialog(item);
        } else {
            alert("该嘉宾暂无视频资源");
        }
    }
    start() {
        this.isTeacherSwiperRun = true;
        //@ts-ignore
        this.$refs.teacherSwiper.$swiper.autoplay.start();
    }
    SwiperHoverIn(event: any) {
        // console.log("swiperHoverIn");
        //@ts-ignore
        // this.$refs.teacherSwiper.$swiper.autoplay.pause();

        //@ts-ignore
        this.$refs.teacherSwiper.$swiper.autoplay.stop();
    }
    SwiperHoverOut(e: any) {
        if (this.isTeacherSwiperRun == true) {
            // console.log("swiperHoverOut");
            //@ts-ignore
            // this.$refs.teacherSwiper.$swiper.autoplay.run();

            //@ts-ignore
            this.$refs.teacherSwiper.$swiper.autoplay.start();
        }
    }
    test() {
        alert(1);
    }
    TeacherHoverIn(e: any, i?: any, item?: any) {
        // console.log("teacherHoverIn");
        // this.headImgHoverIndex = i;
    }
    TeacherHoverOut(e: any, i?: any, item?: any) {
        // console.log("teacherHoverOut");
    }
    mounted() {
        // @ts-ignore
        // console.log(this.$refs.mySwiper.$swiper);
    }
    activated() {
        this.iskeepAutoplay = true;
    }
    deactivated() {
        this.iskeepAutoplay = false;
    }
}
